import { ReactSelectBox } from 'client/CommonComponents';
import TickIcon from 'client/CommonComponents/Icons/TickIcon';
import { CONSTANTS } from 'client/utils/constants';
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getPrimaryApprover, setPrimaryApprover } from 'Store/Identity/PrimaryApprover/PrimaryApproverAction';
import { getAdditionalApprovalListAssignment, getAllApprovalListExcelData, getApprovalListAssignment, getApprovalListExcelData, saveApprovalListAssignment, setAllApprovalListExcelData, setApprovalListAssignment, setApprovalListExcelData, setIsApprovalListSaved, setIsApprovalListValidated, validateApprovalListAssignment } from 'Store/OrderManagement/ApprovalListAssignment/ApprovalListAssignmentAction';
import { getCostCenterBySearchString } from 'Store/Organization/CostCenters/CostCentersAction';
import { getMarketDropDown } from 'Store/Organization/Market/MarketAction';
import { getRegion, getRegionDropDown } from 'Store/Organization/Region/RegionAction';
import ApprovalListAssignment from './ApprovalListAssignment'
import ConfirmationBee from "../../../../assets/images/PenndingApproval/Confirmation Bee.png";
import successBee from "../../../../assets/images/SuccessBee.svg";
import RejectedBee from "../../../../assets/images/PenndingApproval/Rejected Bee.png";
import { base64ToArrayBuffer, saveByteArray } from 'utils';
import { getCostCenterByMarket } from 'Store/Organization/CostCenterByMarket/CostCenterByMarketAction';

const ApprovalListAssignmentContainer = () => {

  const dispatch = useDispatch();

  const [regionDropDownList, setRegionDropDownList] = useState<any>([])
  const [selectedRegion, setSelectedRegion] = useState<any>();

  const [marketDropDownList, setMarketDropDownList] = useState<any>([])
  const [selectedMarket, setSelectedMarket] = useState<any>();

  const [costCenterDropdownList, setCostCenterDropdownList] = useState([]);
  const [selectedCostCenter, setSelectedCostCenter] = useState<any>()

  const [selectedStep, setSelectedStep] = useState<any>()

  const [isEditList, setIsEditList] = useState<any>(false)
  const [showListGrid, setShowListGrid] = useState<any>(false);

  const [assignmentListName, setAssignmentListName] = useState<string>("")
  const [isChangedOccured, setIsChangeOccured] = useState<boolean>(false)

  const [assignmentListGridData, setAssignmentListGridData] = useState<any[]>([])
  const [additionalApprovalListGridData, setAdditionalApprovalListGridData] = useState<any[]>([])

  const [costCentersBySearchList, setCostCentersBySearchList] = useState([])
  const [selectedSearchedCostCenter, setSelectedSearchedCostCenter] = useState<any>()

  const [showValidatePopup, setShowValidatePopup] = useState(false)
  const [selectedKey, setSelectedKey] = useState("approvalListAssignment");
  
  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comment: "",
  });

  ///selectors
  const {
    regionDropDown = [],
    marketDropDown = [],
    costCenterByMarketDropDownList = [],
    getUserDetails,
    approvalListAssignement = [],
    additionalApprovalListAssignment = [],
    primaryApproverList,
    isApprovalListSaved,
    isApprovalListValidated,
    approvalListExcelData = "",
    allApprovalListExcelData = "",
    costCenterBySearchDropDownList = [],
  }: any = useSelector((state: any) => ({
    regionDropDown: state?.RegionDropDownReducer?.regionDropDown,
    marketDropDown: state?.MarketDropDownReducer?.marketDropDown,
    costCenterByMarketDropDownList: state.CostCenterByMarketReducers.costCenterByMarket,
    getUserDetails: state.UserProfile.getUserDetails,
    approvalListAssignement: state?.ApprovalListAssignmentReducer?.approvalListAssignement,
    additionalApprovalListAssignment: state?.ApprovalListAssignmentReducer?.additionalApprovalListAssignment,
    isApprovalListSaved: state?.ApprovalListAssignmentReducer?.isApprovalListSaved,
    isApprovalListValidated: state?.ApprovalListAssignmentReducer?.isApprovalListValidated,
    approvalListExcelData: state?.ApprovalListAssignmentReducer?.approvalListExcelData,
    allApprovalListExcelData: state?.ApprovalListAssignmentReducer?.allApprovalListExcelData,
    primaryApproverList: state.PrimaryApproverReducer.primaryApproverList,
    costCenterBySearchDropDownList: state.CostCentersReducer.costCenterBySearchDropDownList
  }))

  useEffect(() => {
    dispatch(getRegionDropDown());
    setAssignmentListGridData([])
    setAdditionalApprovalListGridData([])
    setShowListGrid(false)
    dispatch(setApprovalListAssignment(null))
  }, [])

  useEffect(() => {
    if (regionDropDown?.length) {
      const regionDropDownTemp = regionDropDown?.map((item: any) =>
        ({ label: item.text, key: item.value, ...item })
      );
      setRegionDropDownList(regionDropDownTemp);
      if(regionDropDownTemp?.length == 1){
        dispatch(getMarketDropDown(regionDropDownTemp[0]?.key))
        setSelectedRegion(regionDropDownTemp[0])
        setAssignmentListName(CONSTANTS?.LOCATION?.REGION)
        const payload = { entityId: regionDropDownTemp[0]?.value, entityType: CONSTANTS?.LOCATION?.REGION }
        dispatch(getApprovalListAssignment(payload))
        dispatch(getAdditionalApprovalListAssignment(payload))
      }
    }
  }, [regionDropDown])

  useEffect(() => {
    if (marketDropDown?.length) {
      const marketDropDownTemp = marketDropDown?.map((item: any) =>
        ({ label: item.text, key: item.value, ...item })
      );
      setMarketDropDownList(marketDropDownTemp);
      if(marketDropDownTemp?.length == 1){
        dispatch(getCostCenterByMarket({marketId : marketDropDownTemp[0]?.key},true))
        setSelectedMarket(marketDropDownTemp[0])
        setAssignmentListName(CONSTANTS?.LOCATION?.MARKET)
        const payload = { entityId: marketDropDownTemp[0]?.value, entityType: CONSTANTS?.LOCATION?.MARKET }
        dispatch(getApprovalListAssignment(payload))
        dispatch(getAdditionalApprovalListAssignment(payload))
      }
    }
  }, [marketDropDown])

  useEffect(() => {
    if (costCenterByMarketDropDownList?.length) {
      const costCenterDropdownListTemp = costCenterByMarketDropDownList?.map((item: any, _index: number) => ({ ...item, label: item?.text }));
      setCostCenterDropdownList(costCenterDropdownListTemp);
      if(costCenterDropdownListTemp?.length == 1){
        setSelectedCostCenter(costCenterDropdownListTemp[0])
        setAssignmentListName(CONSTANTS?.LOCATION?.COST_CENTER)
        const payload = { entityId: costCenterDropdownListTemp[0]?.value, entityType: CONSTANTS?.LOCATION?.COST_CENTER }
        dispatch(getApprovalListAssignment(payload))
        dispatch(getAdditionalApprovalListAssignment(payload))
      }
    }
  }, [costCenterByMarketDropDownList])

  useEffect(() => {
    if (costCenterBySearchDropDownList?.length) {
      const costcenterDropdownListTemp = costCenterBySearchDropDownList?.map((item: any) => ({ ...item, label: item?.text }));
      setCostCentersBySearchList(costcenterDropdownListTemp);
    }
  }, [costCenterBySearchDropDownList])

  useEffect(() => {
    if (approvalListAssignement?.length && (selectedRegion || selectedMarket || selectedSearchedCostCenter)) {
      setShowListGrid(false)
      setIsEditList(false)
      setTimeout(() => {
      setShowListGrid(true)
      })
      setAssignmentListGridData(JSON.parse(JSON.stringify(approvalListAssignement)))
    } else {
      setAssignmentListGridData([])
    }
  }, [approvalListAssignement])

    useEffect(() => {
      if (additionalApprovalListAssignment?.length && (selectedRegion || selectedMarket || selectedSearchedCostCenter)) {
        setShowListGrid(false)
        setIsEditList(false)
        setTimeout(() => {
          setShowListGrid(true)
        })
      setAdditionalApprovalListGridData(JSON.parse(JSON.stringify(additionalApprovalListAssignment)))
    } else {
      setAdditionalApprovalListGridData([])
    }
  }, [additionalApprovalListAssignment])

  useEffect(() => {
      if ((assignmentListGridData?.length || additionalApprovalListGridData?.length) && (selectedRegion || selectedMarket || selectedSearchedCostCenter)) {
      setShowListGrid(false)
      setTimeout(() => {
        setShowListGrid(true);
      })
    }
  }, [isEditList])

  useEffect(() => {
      let titleDropDownListValue = primaryApproverList?.map((item: any) =>
        ({ value: item.value, label: item.text, key: item.value })
      );
      const isAdditionalApprover = selectedKey === "additionalApprovers";
      
      if(isAdditionalApprover) {
        setAdditionalApprovalListGridData(prevData => 
          prevData?.map((valTemp: any) => {
            if (valTemp?.stepNumber == selectedStep) {
              return { ...valTemp, approverOptions: titleDropDownListValue, isLoad: false }
            }
            return valTemp
          })
        )
      } else {
        setAssignmentListGridData(prevData => 
          prevData?.map((valTemp: any) => {
            if (valTemp?.stepNumber == selectedStep) {
              return { ...valTemp, approverOptions: titleDropDownListValue, isLoad: false }
            }
            return valTemp
          })
        )
      }
  }, [primaryApproverList])

  useEffect(() => {
    if (typeof isApprovalListSaved == 'boolean') {
      const message = isApprovalListSaved ? "Changes Updated successfuly" : "Error saving changes, Please try again"
      setPopupcontent({
        ...Popupcontent,
        titleImg: isApprovalListSaved ? successBee : RejectedBee,
        title: isApprovalListSaved ? "SUCCESS" : "ERROR",
        isDialogVisible: true,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        isTitleWarning: false,
        subtextcontent: message,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: () => {
          dispatch(setIsApprovalListSaved(undefined))
          hideDialog();
          if(!isApprovalListSaved){
            setIsEditList(true)
          }
        }
      })
    }
  }, [isApprovalListSaved])

  useEffect(() => {
    if (isApprovalListValidated) {
      const { message, entityId } = getValidationMessage(isApprovalListValidated)
      if(!isApprovalListValidated?.hasDuplicate){
        dispatch(saveApprovalListAssignment(getPayload(entityId)))
        dispatch(setIsApprovalListValidated(undefined))
        hideDialog();
      }
      else if(isApprovalListValidated?.hasDuplicate){
        setPopupcontent({
          ...Popupcontent,
          titleImg: ConfirmationBee,
          title: "CONFIRMATION",
          isDialogVisible: true,
          isCommentboxVisible: false,
          isCommentBoxRequire: false,
          isTitleWarning: false,
          subtextcontent: message,
          primaryBtnText: "Yes",
          outlineBtnText: "No",
          popupOutlinebtnOnclick: () => {
              dispatch(setIsApprovalListValidated(undefined));
              hideDialog();
              setIsEditList(true);
          },
          popupPrimarybtnOnclick: () => {
              setIsEditList(false);
              dispatch(setIsApprovalListValidated(null));
              setIsChangeOccured(false);
              dispatch(saveApprovalListAssignment(getPayload(entityId)));
          }
        });        
      }
      else if(isApprovalListValidated?.isError){
        setPopupcontent({
          ...Popupcontent,
          titleImg: RejectedBee,
          title: "ERROR",
          isDialogVisible: true,
          isCommentboxVisible: false,
          isCommentBoxRequire: false,
          isTitleWarning: false,
          subtextcontent: message,
          isSingleConfirmationBtn: true,
          popupOutlinebtnOnclick: () => {
              dispatch(setIsApprovalListValidated(undefined));
              hideDialog();
              setIsEditList(true);
          }
        });        
      }
      }
  }, [isApprovalListValidated])

  useEffect(()=>{
    if(approvalListExcelData){
        const byteArray = base64ToArrayBuffer(approvalListExcelData)
        saveByteArray('Approval_List_Assignment', byteArray, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        dispatch(setApprovalListExcelData(null))
    }
}, [approvalListExcelData])

useEffect(()=>{
  if(allApprovalListExcelData){
      const byteArray = base64ToArrayBuffer(allApprovalListExcelData)
      saveByteArray('All_Approval_List_Assignment', byteArray, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
      dispatch(setAllApprovalListExcelData(null))
  }
}, [allApprovalListExcelData])

  const hideDialog = () => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
  }

  const handleChangeEditList = (e: any, value: any) => {
    if (isEditList && isChangedOccured) {
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "UNSAVED CHANGES",
        isDialogVisible: true,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        isTitleWarning: false,
        subtextcontent: "You have unsaved changes:   Click Ok to discard your changes, or Close to continue editing.",
        primaryBtnText: "Ok",
        outlineBtnText: "Close",
        isSingleConfirmationBtn: false,
        popupOutlinebtnOnclick: () => {
          hideDialog();
        },
        popupPrimarybtnOnclick: () => {
          setAssignmentListGridData(approvalListAssignement)
          setIsEditList(value)
          setIsChangeOccured(false)
          hideDialog();
        }
      })
    } else {
      setIsEditList(value)
    }
  }

  const handleChange = (value: any, name: string) => {
    setSelectedSearchedCostCenter('')
    switch (name) {
      case "region":
        setSelectedRegion(value);
        setAssignmentListName(CONSTANTS?.LOCATION?.REGION)
        setSelectedMarket('')
        setSelectedCostCenter('')
        dispatch(getMarketDropDown(value?.key))
            setShowListGrid(false)
            dispatch(getApprovalListAssignment({ entityId: value?.key, entityType: CONSTANTS?.LOCATION?.REGION }))
        dispatch(getAdditionalApprovalListAssignment({ entityId: value?.key, entityType: CONSTANTS?.LOCATION?.REGION }))
        break;
      case "market":
        setSelectedMarket(value);
        setAssignmentListName(CONSTANTS?.LOCATION?.MARKET)
        setSelectedCostCenter('')
        dispatch(getCostCenterByMarket({marketId : value?.key},true))
        dispatch(getApprovalListAssignment({ entityId: value?.value, entityType: CONSTANTS?.LOCATION?.MARKET }))
        dispatch(getAdditionalApprovalListAssignment({ entityId: value?.value, entityType: CONSTANTS?.LOCATION?.MARKET }))
        setShowListGrid(true)
        break;
      case "costCenter":
        setSelectedCostCenter(value);
        setAssignmentListName(CONSTANTS?.LOCATION?.COST_CENTER)
        dispatch(getApprovalListAssignment({ entityId: value?.value, entityType: CONSTANTS?.LOCATION?.COST_CENTER }))
        dispatch(getAdditionalApprovalListAssignment({ entityId: value?.value, entityType: CONSTANTS?.LOCATION?.COST_CENTER }))
        setShowListGrid(true)
        break;
      default:
        break;
    }
  }

  const onChangeAssignmentList = (val: any, columnName: any, selectedApprover?: any) => {
    setIsChangeOccured(true)
    const isAdditionalApprover = selectedKey === "additionalApprovers";
    
    // Clear the search results after selection to restore original behavior
    dispatch(setPrimaryApprover([]))
    
    // Use functional state update to preserve existing user selections
    const updateGridData = (prevData: any[]) => {
      const emailCount: any = {};
      
      return prevData?.map((valTemp: any) => {
      if (valTemp?.stepNumber == val?.stepNumber) {
        valTemp.approver = selectedApprover
        valTemp.userEmail = selectedApprover.value
        valTemp.error = ''
      }

      const email = valTemp?.userEmail;

      if (email && email.length > 1) {
        emailCount[email] = (emailCount[email] || 0) + 1;

        if (emailCount[email] > 1) {
          return { ...valTemp, error: 'An approver must not be selected more than once.' };
        }
      }

      return valTemp
    })
  };
  
  if(isAdditionalApprover) {
    setAdditionalApprovalListGridData(updateGridData)
  } else {
    setAssignmentListGridData(updateGridData)
  }
  }

  const filterOptionsApprovers = (value: any, action: any, id: any) => {
    if (action.action === "input-change" && value?.length > 3) {
      const isAdditionalApprover = selectedKey === "additionalApprovers";
      setSelectedStep(id)
      dispatch(getPrimaryApprover(value.replace(/[^\w\s]/gi, ""), 'Primary'));

      // Use functional state update to preserve current state with user selections
      if(isAdditionalApprover) {
        setAdditionalApprovalListGridData(prevData => 
          prevData?.map((valTemp: any) => {
            if (valTemp?.stepNumber == id) {
              return { ...valTemp, isLoad: true }
            }
            return valTemp
          })
        )
      } else {
        setAssignmentListGridData(prevData => 
          prevData?.map((valTemp: any) => {
            if (valTemp?.stepNumber == id) {
              return { ...valTemp, isLoad: true }
            }
            return valTemp
          })
        )
      }
    }
  };

  const approvalListAssignmentColumns = [
    {
      key: "stepNumber",
      title: "Approver#",
      width: 180
    },
    {
      key: "title",
      title: "Title",
      width: 180
    },
    {
      key: "approver",
      title: "Approver",
      Cell: (row: any) => {
        if (isEditList) {
          return (
            <>
              <ReactSelectBox
                name='approver'
                options={row?.rowData?.approverOptions ?? []}
                onChange={(value: any) => onChangeAssignmentList(row?.rowData, row?.column?.title, value)}
                value={typeof row?.rowData?.approver == 'object' ? row?.rowData?.approver : { label: row?.rowData?.userName, value: row?.rowData?.userEmail }}
                isSearchable={true}
                placeholder='Search Approver'
                className={`mb-3 ${row?.rowData?.error ? 'controlValidation' : ''}`}
                isLoading={row?.rowData?.isLoad}
                noOptionsMessage={() => "Not Available"}
                onInputChange={(value: any, action: any) => filterOptionsApprovers(value, action, row?.rowData?.stepNumber)}
               data-attribute="ApprovalListAssignment_container_approver_SearchSelectBox" />
              {row?.rowData?.error ? <p className='validMessage'>{row?.rowData?.error}</p> : null}
            </>
          );
        } else if (typeof row?.rowData?.approver == 'object') {
          return <p>{row?.rowData?.approver?.label}</p>
        } else {
          return <p>{row?.rowData?.userName}</p>
        }
      },
      width: 180
    },
    {
      key: "isRequisition",
      title: "Requisitions",
      Cell: (row: any) => row?.rowData?.isRequisition ? <TickIcon /> : null,
      width: 180
    },
    {
      key: "isDisposition",
      title: "Dispositions",
      Cell: (row: any) => row?.rowData?.isDisposition ? <TickIcon /> : null,
      width: 180
    },
    {
      key: "isSendingTransfer",
      title: "Sending Transfers",
      Cell: (row: any) => row?.rowData?.isSendingTransfer ? <TickIcon /> : null,
      width: 180
    },
    {
      key: "isReceivingTransfer",
      title: "Receiving Transfers",
      Cell: (row: any) => row?.rowData?.isReceivingTransfer ? <TickIcon /> : null,
      width: 180
    },
    {
      key: "isReactivation",
      title: "Reactivations",
      Cell: (row: any) => row?.rowData?.isReactivation ? <TickIcon /> : null,
      width: 180
    },
    {
      key: "isAFEFleet",
      title: "AFE - Fleet",
      Cell: (row: any) => row?.rowData?.isAFEFleet ? <TickIcon /> : null,
      width: 180
    },
    {
      key: "isAFENonFleet",
      title: "AFE - NonFleet",
      Cell: (row: any) => row?.rowData?.isAFENonFleet ? <TickIcon /> : null,
      width: 180
    },
  ];

  const additionalApproversColumns = [
    {
      key: "stepNumber",
      title: "Approver#",
      width: 180
    },
    {
      key: "title",
      title: "Title",
      width: 180
    },
    {
      key: "approver",
      title: "Approver",
      Cell: (row: any) => {
        if (isEditList) {
          return (
            <>
              <ReactSelectBox
                name='approver'
                options={row?.rowData?.approverOptions ?? []}
                onChange={(value: any) => onChangeAssignmentList(row?.rowData, row?.column?.title, value)}
                value={typeof row?.rowData?.approver == 'object' ? row?.rowData?.approver : { label: row?.rowData?.userName, value: row?.rowData?.userEmail }}
                isSearchable={true}
                placeholder='Search Approver'
                className={`mb-3 ${row?.rowData?.error ? 'controlValidation' : ''}`}
                isLoading={row?.rowData?.isLoad}
                noOptionsMessage={() => "Not Available"}
                onInputChange={(value: any, action: any) => filterOptionsApprovers(value, action, row?.rowData?.stepNumber)}
               data-attribute="ApprovalListAssignment_container_approver_SearchSelectBox_2" />
              {row?.rowData?.error ? <p className='validMessage'>{row?.rowData?.error}</p> : null}
            </>
          );
        } else if (typeof row?.rowData?.approver == 'object') {
          return <p>{row?.rowData?.approver?.label}</p>
        } else {
          return <p>{row?.rowData?.userName}</p>
        }
      },
      width: 180
    }
  ];

  const validateList = () => {
    const isAdditionalApprover = selectedKey === "additionalApprovers";
    const currentGridData = isAdditionalApprover ? additionalApprovalListGridData : assignmentListGridData;
    
    let isValid = true;
    let hasUserEmailForWorkflows = false;
    const emailCount : any = {};
    const validationList = currentGridData?.map((item) => {

      // Check if this step has any workflows enabled
      const hasEnabledWorkflows = item?.isRequisition || item?.isDisposition || 
        item?.isSendingTransfer || item?.isReceivingTransfer || item?.isReactivation || item?.isAFEFleet || item?.isAFENonFleet;

      if(assignmentListName == CONSTANTS?.LOCATION?.COST_CENTER){
        hasUserEmailForWorkflows = true;
        if (!item?.userEmail && hasEnabledWorkflows) {
          isValid = false;
          return { ...item, error: 'Approver is Required' };
        }
      } else {
        if (hasEnabledWorkflows) {
          if (item?.userEmail) {
            hasUserEmailForWorkflows = true; 
          }
        }
      }
     
      const email = item?.userEmail?.toLowerCase();

      if (email && email?.length > 1) {
        emailCount[email] = (emailCount[email] || 0) + 1;

        if (emailCount[email] > 1) {
          isValid = false;
          return { ...item, error: 'An approver must not be selected more than once.' };
        }
      }
  
      return item;
    });

    if (!hasUserEmailForWorkflows) {
      isValid = false;
      setShowValidatePopup(true);
      let decriptionTxt = "Atleast one Approver is required"
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isCommentboxVisible: false,
        isCommentBoxRequire: false,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: () => {
          setShowValidatePopup(false)
          hideDialog();
        },
      });
    }
    
    // Update the appropriate grid data based on the current tab
    if (isAdditionalApprover) {
      setAdditionalApprovalListGridData(validationList);
    } else {
      setAssignmentListGridData(validationList);
    }
    
    return isValid;
  }
  


  const getPayload = (entityId: number) => {
    const isAdditionalApprovers = selectedKey === 'additionalApprovers';
    const tempData = isAdditionalApprovers ? additionalApprovalListGridData : assignmentListGridData;
    let payload: any = {
      entityId: Number(entityId),
      approvals: tempData?.map((item: any) => ({
        stepNumber: item?.stepNumber,
        titleId: item?.titleId,
        title: item?.title,
        isRequisition: item?.isRequisition,
        isDisposition: item?.isDisposition,
        isSendingTransfer: item?.isSendingTransfer,
        isReceivingTransfer: item?.isReceivingTransfer,
        isReactivation: item?.isReactivation,
        approverEmail: item?.userEmail,
        isAFEFleet: item?.isAFEFleet,
        isAFENonFleet: item?.isAFENonFleet,
      })),
      entityType: assignmentListName,
      isOverride: assignmentListName !== CONSTANTS?.LOCATION?.COST_CENTER ? true : false,
      savedBy: getUserDetails?.emailId,
      isAdditionalApprover: isAdditionalApprovers
    }
    return payload
  }

  const getValidationMessage = (isApprovalListValidated : any) =>{
    let message: any;
    let entityId = 0
    if (assignmentListName === CONSTANTS?.LOCATION?.REGION) {
      entityId = selectedRegion?.value
    } else if (assignmentListName === CONSTANTS?.LOCATION?.MARKET) {
      entityId = selectedMarket?.value
    } else if(assignmentListName === CONSTANTS?.LOCATION?.COST_CENTER) {
      entityId = selectedSearchedCostCenter?.value ?? selectedCostCenter?.value
    }
    message = buildApprovalValidationMsg(isApprovalListValidated)
    return { message, entityId }
  }

  const buildApprovalValidationMsg = (isApprovalListValidated : any) =>{
    let message: any;
    if(isApprovalListValidated?.hasDuplicate && isApprovalListValidated?.duplicateApproverEntity){
      message = generateGroupedMessage(isApprovalListValidated?.duplicateApproverEntity)
    }
    else if(isApprovalListValidated?.isError){
      message = "Error Occured While Validating , Please Try Again"
    }
    return message;
  }

  const generateGroupedMessage = (data : any) => {
    const grouped = data.reduce((acc: any, { businessEntityTypeName, businessEntityCodeorNumber, businessEntityName }: any) => {
      if (!acc[businessEntityTypeName]) acc[businessEntityTypeName] = [];
      acc[businessEntityTypeName].push(`${businessEntityCodeorNumber} - ${businessEntityName}`);
      return acc;
    }, {});

    return getDynamicMessage(grouped);
  };

  const getDynamicMessage = (groupedData : any): any => {
    let message: any = `Are you sure you want to save? Duplicate records will be updated in the following: <br/>`;
    
    const marketItems: any = groupedData['Market'] ? groupedData['Market'].join(', ') : '';
    const costCenterItems: any = groupedData['CostCenter'] ? groupedData['CostCenter'].join(', ') : '';

    if (marketItems) message += `Markets: ${marketItems}. <br/>`;
    if (costCenterItems) message += `Cost centers: ${costCenterItems}.`;
    return (<div dangerouslySetInnerHTML={{ __html: message }} /> );
  };

  const getConfirmationMessage = () => {
    let message: any;
    let entityId = 0
    if (assignmentListName === CONSTANTS?.LOCATION?.REGION) {
      message = <p>All markets and cost centers for {CONSTANTS?.LOCATION?.REGION} <strong>{selectedRegion?.text}</strong> will be updated.  Are you sure you want to continue?</p>
      entityId = selectedRegion?.value
    } else if (assignmentListName === CONSTANTS?.LOCATION?.MARKET) {
      message = <p>All cost centers for {CONSTANTS?.LOCATION?.MARKET} <strong>{selectedMarket?.text}</strong> will be updated.  Are you sure you want to continue?</p>
      entityId = selectedMarket?.value
    } else if(assignmentListName === CONSTANTS?.LOCATION?.COST_CENTER) {
      message = <p>Changes for Cost center <strong>{selectedCostCenter?.text}</strong> will be updated.  Are you sure you want to continue?</p>
      entityId = selectedSearchedCostCenter?.value ?? selectedCostCenter?.value
    }
    return { message, entityId }
  }

  const getPopUpConfirmation = () => {
    const { message, entityId } = getConfirmationMessage()
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "CONFIRMATION",
      isDialogVisible: true,
      isCommentboxVisible: false,
      isCommentBoxRequire: false,
      isTitleWarning: false,
      subtextcontent: message,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
      popupOutlinebtnOnclick: () => {
        hideDialog();
      },
      popupPrimarybtnOnclick: () => {
        setIsEditList(false)
        setIsChangeOccured(false)
        dispatch(validateApprovalListAssignment(getPayload(entityId)))
        hideDialog();
      }
    })
  }

  const onSaveClick = () => {
    const isValid = validateList()
    if (isValid) {
      getPopUpConfirmation()
    }
  }

  const getAlertMessage = () => {
    let message: any;
     if (assignmentListName === CONSTANTS?.LOCATION?.REGION) {
      message = <p className="confirmation-block-text">By setting changes at the {CONSTANTS?.LOCATION?.REGION} level all markets and cost centers approvers list will be updated to match the {CONSTANTS?.LOCATION?.REGION} level.</p>
    } else if (assignmentListName === CONSTANTS?.LOCATION?.MARKET) {
      message = <p className="confirmation-block-text">By setting changes at the {CONSTANTS?.LOCATION?.MARKET} level all cost centers approvers list will be updated to match the {CONSTANTS?.LOCATION?.MARKET} level.</p>
    } else if(assignmentListName === CONSTANTS?.LOCATION?.COST_CENTER){
      message = <p className="confirmation-block-text">By setting changes at the Cost Center level only this cost center will be updated with these approvers.</p>
    }
    return message
  }

  const onExportExcel = (e: any) => {
    e.preventDefault()
    const isAdditionalApprover = selectedKey === "additionalApprovers";
    let payload = {
      entityId: getConfirmationMessage()?.entityId,
      entityType: assignmentListName
    }
    dispatch(getApprovalListExcelData(payload, isAdditionalApprover))
  }

  const onAllExportExcel = (e: any) => {
    e.preventDefault()
    const isAdditionalApprover = selectedKey === "additionalApprovers";
    dispatch(getAllApprovalListExcelData(isAdditionalApprover))
  }

  const handleChangeSearchedCostCenter = (value: any, name: string) => {
    setSelectedSearchedCostCenter(value)
    setAssignmentListName(CONSTANTS?.LOCATION?.COST_CENTER)
    dispatch(getApprovalListAssignment({ entityId: value?.value, entityType: CONSTANTS?.LOCATION?.COST_CENTER }))
    dispatch(getAdditionalApprovalListAssignment({ entityId: value?.value, entityType: CONSTANTS?.LOCATION?.COST_CENTER }))
    setShowListGrid(true)
    setSelectedCostCenter('')
    setSelectedMarket('')
    setSelectedRegion('')
  }

  const searchCostCenter = (value: any, action: any) => {
    if (action.action === "input-change") {
      dispatch(getCostCenterBySearchString(value,true))
    }
  };

  const onClearClick = () => {
    dispatch(getRegion());
    setAssignmentListGridData([])
    setShowListGrid(false)
    dispatch(setApprovalListAssignment(null))
    setSelectedSearchedCostCenter('')
    setSelectedCostCenter('')
    setSelectedMarket('')
    setSelectedRegion('')
    setCostCenterDropdownList([])
    setMarketDropDownList([])
    setCostCentersBySearchList([])
    dispatch(setApprovalListExcelData(null))
    dispatch(setIsApprovalListSaved(undefined))
    setShowValidatePopup(false)
  }

  const handleLinkClick = (item?: any) => {
    if (item) {
      setSelectedKey(item.props.itemKey);
    }
  };
  const showAlert = !!selectedRegion || !!selectedMarket || !!selectedCostCenter || !!selectedSearchedCostCenter

  return (
    <ApprovalListAssignment
      regionDropDownList={regionDropDownList}
      selectedRegion={selectedRegion}
      marketDropDownList={marketDropDownList}
      selectedMarket={selectedMarket}
      handleChange={handleChange}
      costCenterDropdownList={costCenterDropdownList}
      selectedCostCenter={selectedCostCenter}
      approvalAssignement={assignmentListGridData ?? []}
      additionalApprovalListGridData={additionalApprovalListGridData ?? []}
      approvalListAssignmentColumns={approvalListAssignmentColumns}
      additionalApproversColumns={additionalApproversColumns}
      isEditList={isEditList}
      handleChangeEditList={handleChangeEditList}
      showGrid={showListGrid}
      onSaveClick={onSaveClick}
      showAlert={showAlert}
      Popupcontent={Popupcontent}
      hideDialog={hideDialog}
      getAlertMessage={getAlertMessage}
      onExportExcel={onExportExcel}
      onAllExportExcel = {onAllExportExcel}
      costCentersBySearchList={costCentersBySearchList}
      handleChangeSearchedCostCenter={handleChangeSearchedCostCenter}
      searchCostCenter={searchCostCenter}
      selectedSearchedCostCenter={selectedSearchedCostCenter}
      onClearClick = {onClearClick}
      showValidatePopup = {showValidatePopup}
      handleLinkClick={handleLinkClick}
      selectedKey={selectedKey}
    />
  )
}

export default ApprovalListAssignmentContainer